(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		headerDetails.addEventListener("toggle", function (e) {
			const colorScheme =
				this.querySelector("#menu-drawer").dataset.colorScheme;
				if (window.innerWidth > 576) {
					header.classList.toggle(colorScheme);
				}

				if (window.innerWidth <= 576 && !header.classList.contains(colorScheme)) {
					header.classList.add(colorScheme);
				}
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		$(".header__icon--account").click(function (e) {
			$(".search-modal").removeClass("active");
		});

		const announcementBar = document.querySelector(".announcement-bar");
		const headerOffcanvas = document.querySelector(".burger-drawer");

		announcementBar &&
			headerOffcanvas &&
			headerOffcanvas.classList.add("announcement-bar-show");

		$(window).scroll(function () {
			if ($(window).scrollTop() > 100) {
				announcementBar &&
					headerOffcanvas &&
					headerOffcanvas.classList.add("announcement-bar-hide");
				announcementBar &&
					headerOffcanvas &&
					headerOffcanvas.classList.remove("announcement-bar-show");
			} else {
				announcementBar &&
					headerOffcanvas &&
					headerOffcanvas.classList.remove("announcement-bar-hide");
				announcementBar &&
					headerOffcanvas &&
					headerOffcanvas.classList.add("announcement-bar-show");
			}
		});
		
		$(".shopify-section-header").hover(
			function () {
				if (
					!$(".burger-drawer").hasClass("active") ||
					!$("#search-modal").hasClass("active")
				) {
					$(".shopify-section-header").addClass("color-background-1");
				}
			},
			function () {
				if (
					$(".burger-drawer").hasClass("active") ||
					$("#search-modal").hasClass("active")
				) {
					$(".shopify-section-header").addClass("color-background-1");
				} else {
					$(".shopify-section-header").removeClass("color-background-1");
				}
			}
		);
	};
	document.addEventListener("shopify:section:load", header);
	header();

	// ===================================
	// GESTION DES MENUS IMBRIQUÉS
	// ===================================
	const headerNestedMenu = () => {
		const dir = document.querySelector('html').getAttribute("dir");
		const listMenu = document.querySelector(".header__menu .list-menu");
		
		if (!listMenu) return;
		
		const listMenuRect = listMenu.getBoundingClientRect();
		const viewportWidth = window.innerWidth;
		const viewportHeight = window.innerHeight;

		// Fonction pour vérifier et ajuster le positionnement
		const checkSubmenuPosition = (submenu, parentLi) => {
			if (!submenu) return;
			
			// Attendre que le submenu soit visible pour mesurer
			submenu.style.visibility = 'hidden';
			submenu.style.opacity = '1';
			submenu.style.pointerEvents = 'auto';
			
			setTimeout(() => {
				const submenuRect = submenu.getBoundingClientRect();
				const isSecondLevel = submenu.classList.contains('header__submenu-second_level');
				const isThirdLevel = submenu.classList.contains('header__submenu-third_level');
				
				// Vérifier le débordement horizontal
				if (isSecondLevel || isThirdLevel) {
					if (dir === "rtl") {
						// En RTL, vérifier le débordement à gauche
						if (submenuRect.left < 0) {
							submenu.style.left = '100%';
							submenu.style.right = 'auto';
							submenu.classList.remove('position-left');
						}
					} else {
						// En LTR, vérifier le débordement à droite
						if (submenuRect.right > viewportWidth) {
							submenu.style.left = 'auto';
							submenu.style.right = '100%';
							submenu.style.marginLeft = '0';
							submenu.style.marginRight = '0.5rem';
							submenu.classList.add('position-left');
						} else {
							submenu.classList.remove('position-left');
						}
					}
				}
				
				// Vérifier le débordement vertical
				if (submenuRect.bottom > viewportHeight) {
					const overflow = submenuRect.bottom - viewportHeight;
					submenu.style.top = `-${overflow + 10}px`;
				}
				
				// Remettre la visibilité normale
				submenu.style.visibility = '';
				submenu.style.opacity = '';
				submenu.style.pointerEvents = '';
			}, 10);
		};

		// Gérer tous les sous-menus de tous niveaux
		const allMenuItems = listMenu.querySelectorAll('.list-menu-has-child');
		
		allMenuItems.forEach(item => {
			const submenu = item.querySelector(':scope > .header__submenu');
			
			// Vérifier au hover
			item.addEventListener('mouseenter', () => {
				checkSubmenuPosition(submenu, item);
			});
			
			// Réinitialiser au départ de la souris
			item.addEventListener('mouseleave', () => {
				if (submenu) {
					submenu.style.top = '';
					submenu.style.left = '';
					submenu.style.right = '';
				}
			});
		});
	};

	// Initialiser au chargement
	headerNestedMenu();
	
	// Réinitialiser au redimensionnement
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			headerNestedMenu();
		}, 250);
	});
	
	// Réinitialiser lors du chargement de section Shopify
	document.addEventListener('shopify:section:load', () => {
		headerNestedMenu();
	});

})();
